import React from 'react';
import PropTypes from 'prop-types';
import Question from './Question';
import './faq-styles.scss';
import { decodeTags, isValid, isText, sendLog } from '../../../../utils';

const FAQ= ({
  data,
  className,
}) => {
	const { questions } = data;
	let renderedQuestions; 

	if (isValid(questions)) {
		renderedQuestions = questions.map((question, i) => {
			return (
	    		<Question
			        question={question.question}
			        answer={question.answer} />
	    	);
    	});
	}

	return (
		<div className={className}>
		  	<h2 id="faq" className="faq-title">Frequently Asked Questions</h2>
		  	{renderedQuestions}
		</div>
	)
};

FAQ.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

export default FAQ;
